export const incomeColumns = [
    {
        Header: "Description",
        accessor: "description",
    },
    {
        Header: "Transaction ID",
        accessor: "transactionId",
    },
    {
        Header: "Card",
        accessor: "card",
    },
    {
        Header: "Amount",
        accessor: "amount",
    },
    {
        Header: "Receipt",
        accessor: "receipt",
    },
]

export const incomeTableData = [
    {
        description: "Clover",
        transactionId: "#10548796",
        card: "1234 ****",
        date: "20 Jan, 09.30 AM",
        amount: "$2,5000",
        amountColor: "text-green-500",
    },
    {
        description: "Elodie",
        transactionId: "#12548796",
        card: "5237 ****",
        date: "28 Jan, 12.30 AM",
        amount: "$35,500",
        amountColor: "text-green-500",
    },
    {
        description: "Emilly",
        transactionId: "#16548796",
        card: "7567 ****",
        date: "02 Jan, 01.30 AM",
        amount: "+$2,500",
        amountColor: "text-green-500",
    },
    {
        description: "Felix",
        transactionId: "#14548706",
        card: "7654 ****",
        date: "22 Jan, 11.30 AM",
        amount: "$2,0000",
        amountColor: "text-green-500",
    },
    {
        description: "Wilson",
        transactionId: "#12548796",
        card: "3418 ****",
        date: "	28 Jan, 12.30 AM",
        amount: "$10,500",
        amountColor: "text-green-500",
    },
]